import { Link } from 'models/Navigation'
import { useSelector } from 'react-redux'
import { getUserLoggedInState } from 'redux/reducers/users'
import { Button } from 'components/Button/Button'
import events, { Event } from 'pubsub/events'
import i18n from 'i18n/config'

interface NavLinkListProps {
  analyticsCategory: string;
  label: string;
  description?: string;
  links: Link[];
  menuName: string;
}

export const NavLinkList: React.FC<NavLinkListProps> = ({ label, description, links, menuName, analyticsCategory }) => {
  const isLoggedIn = useSelector(getUserLoggedInState)

  const sendClickEvent = (link: Link) => {
    const options: Event = {
      authenticated: isLoggedIn,
      text: link.label,
      targetLocation: link.href,
      heading: menuName,
      subheading: label,
      category: analyticsCategory,
      activity: 'Link Click',
      url: window.location.href,
      language: i18n.language,
      title: document.title,
      sendToTealium: true,
      sendToCoreAPI: true,
      isMessageCenter: false

    }

    events.publish(options)
  }

  return (
    <div className='ds-u-sans ds-u-margin--3'>
      <h2 className='ds-u-font-size--md ch-c-mobile-menu__section-label ds-u-margin-bottom--2'>{label}</h2>

      {description && <p className='ds-u-font-size--base ds-u-color--base ds-u-margin-left--3 ds-u-margin-bottom--2'>{description}</p>}

      <ul className='ds-u-padding--0 ds-u-padding-left--3 ds-u-margin-top--2' style={{ listStyle: 'none' }}>
        {links.map((link: Link) => (
          <li key={link.id} className='ds-u-margin-bottom--2'>
            <Button
              isMbpRedirect={link.isMbpRedirect}
              className='ch-c-nav-menu-link'
              href={link.href}
              onClick={() => sendClickEvent(link)}
            >
              {link.label}
            </Button>

          </li>
        ))}
      </ul>
    </div>
  )
}
